import { useEffect, useState, useCallback } from "react";
import { Circle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export const LiveListeners = () => {
  const [listenerCount, setListenerCount] = useState(0);
  const [displayCount, setDisplayCount] = useState(0);

  // Fetch display count from edge function
  const fetchDisplayCount = useCallback(async (actualCount: number) => {
    try {
      const { data, error } = await supabase.functions.invoke('listener-count', {
        body: null,
        method: 'GET',
      });
      
      if (error) {
        console.error('Error fetching listener count:', error);
        return;
      }
      
      if (data?.count) {
        setDisplayCount(data.count);
      }
    } catch (err) {
      console.error('Failed to fetch listener count:', err);
    }
  }, []);

  // Track presence for actual listener count
  useEffect(() => {
    const channel = supabase.channel('live-listeners', {
      config: {
        presence: {
          key: Math.random().toString(36).substring(7),
        },
      },
    });

    channel
      .on('presence', { event: 'sync' }, () => {
        const state = channel.presenceState();
        const count = Object.keys(state).length;
        setListenerCount(count);
      })
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({
            online_at: new Date().toISOString(),
          });
        }
      });

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  // Fetch display count from backend periodically
  useEffect(() => {
    fetchDisplayCount(listenerCount);
    const interval = setInterval(() => fetchDisplayCount(listenerCount), 3000);
    return () => clearInterval(interval);
  }, [listenerCount, fetchDisplayCount]);

  return (
    <div className="flex items-center gap-2 text-foreground/80">
      <Circle className="h-2 w-2 fill-red-500 text-red-500 animate-pulse" />
      <span className="text-sm font-medium">
        {displayCount} {displayCount === 1 ? 'listener' : 'listeners'} live
      </span>
    </div>
  );
};
